export default __webpack_public_path__ + "static/media/x-bitcoinAssetWallet.ac1689be.svg";